import { useQuery } from "@tanstack/react-query";
import { GetStockHistory } from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { DEFAULT_STALE_TIME, STALE_TIME_0 } from "../Constant/AppConstants";

export const stockHistoryQueryKeys = {
  stockHistory: (params?: Parameters<typeof GetStockHistory>[0]) =>
    ["stockHistory", params] as const,
};

export const useStockHistoryQuery = (
  params: Parameters<typeof GetStockHistory>[0],
  options?: ServiceQueryOptions,
) => {
  return useQuery({
    staleTime: STALE_TIME_0,
    ...options,
    queryKey: stockHistoryQueryKeys.stockHistory(params),
    queryFn: async () => {
      const res = await GetStockHistory(params);
      if (!res?.success) {
        return { data: [], total: 0 };
      }
      const rawData = res.data;
      const historyList = Array.isArray(rawData)
        ? rawData
        : Array.isArray(rawData?.data)
          ? rawData.data
          : [];
      return {
        data: historyList,
        total: res.meta?.total ?? historyList.length,
      };
    },
  });
};
